export default "__VITE_ASSET__CuXagEcR__"